import React, { useState, useEffect, useRef } from 'react';
import {
    TextField, Autocomplete, Button, IconButton, InputAdornment
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useParams,useNavigate } from 'react-router-dom';
import { fetchAllGarmentTypes, fetchAllLabels, createTagRequest, uploadPdf } from '../../../redux/tagSlice';
import SuccessModal from "../../../components/Modals/SuccessfulModal";
import {toast} from 'react-hot-toast';

const nonEngChar = /[^-A-Za-z0-9_@,.:;{}/&%()'"#*<>!$?+\n ]/;
export const CREATE_TAG_REQUEST_VALIDATION = yup.object().shape({
    address: yup.string().required('Delivery address is required.')
    .max(100, 'Delivery address cannot exceed 100 characters')
    .test('non-eng-char', 'Delivery address should not contain non-English characters.', (value) => !nonEngChar.test(value)),
    contactName: yup.string().required('Contact Person Name is required.')
    .max(100, 'Contact Person Name cannot exceed 100 characters')
    .test('non-eng-char', 'Contact Person Name should not contain non-English characters.', (value) => !nonEngChar.test(value)),
    color: yup.string().required('Color is required.')
    .max(200, 'Color cannot exceed 200 characters')
    .test('non-eng-char', 'Color should not contain non-English characters.', (value) => !nonEngChar.test(value)),
    gst: yup.string().required('GST Number is required.')
    .max(100, 'GST Number cannot exceed 100 characters')
    .test('non-eng-char', 'GST Number should not contain non-English characters.', (value) => !nonEngChar.test(value)),
    email: yup.string().required('Email is required.')
    .max(100, 'Color cannot exceed 100 characters')
    .matches(
        /^([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6})(\s*,\s*[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6})*$/i, // validation for comma-separated mails
        'Invalid email format.'
      ),
    label: yup.string().required('Brand Label is required.'),
    garmentType: yup.string().required('Garment Type is required.'),
    pincode: yup.number().required('Pincode is required.'),
    contactNo: yup.number().required('Contact Number is required.'),

});

const CreateTagRequest = (order) => {

    console.log("order",order);
    const quantityRequested = order.order.orderProducts.reduce((total, product) => {
        const productQty = parseInt(product.productQty);
        return total + (isNaN(productQty) ? 0 : productQty);
    }, 0);

    const companyRole = useSelector((state) => state.auth.userDetails?.company?.companyRoles || []);
    const navigatePage = companyRole === 'BR' ? '/outbox-order' : '/inbox-order';
    
    // console.log("quantityRequested",quantityRequested);
    const fileInputRef1 = useRef(null);
    const fileInputRef2 = useRef(null);
    const [tracerCertificateFile, settracerCertificateFile] = useState("");
    const [fptGptreportFile, setFptGptreportFileFile] = useState("");
    const [fileUrl, setFileUrl] = useState("");
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [isSubmit, setIsSubmit] = useState(true);
    const [initialState, setInitialState] = useState({
        orderId: order.order.orderId,    
        orderNumber: order.order.orderNumber,  
        label: '', 
        styleNo: order.order.orderNumber, 
        color: '',  
        remarks: '', 
        fibre: order.order.orderProducts[0].blendPercentage,  
        garmentType: '',  
        gst: '',  
        address: '',  
        pincode: '',   
        contactNo: '',  
        contactName: '',  
        email: '',  
        quantityRequested: quantityRequested,   
        tracerCertificateName: {},  
        fptGptReportName: {},  
    });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const [ garmentTypeList, setGarmentTypeList] = useState([]);
    // console.log("garmentTypeList",garmentTypeList);
    const garmentTypes = useSelector(state => state.tag.garmentTypes || []);
    const garmentTypeOptions = garmentTypes.map(garment => ({
        label: garment.garment_type,
        value: garment.garment_type,
    }));

    // const [ labels, setLabels] = useState([]);
    // console.log("labels",labels);
    const labels = useSelector(state => state.tag.labels || []);
    const labelOptions = labels.map(label => ({
        label: label.label_name,
        value: label.label_name,
    }));

    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const garments = await fetchAllGarmentTypes();
    //             setGarmentTypeList(garments);
    //             const labels = await fetchAllLabels();
    //             setLabels(labels);
    //             console.log("garments", garments, "labels", labels);
    //         } catch (error) {
    //             console.error('Error fetching data:', error);
    //         }
    //     };
    
    //     fetchData();
    // }, []);

    useEffect(() => {
        console.log("USEEFFECT CALLED!")
        dispatch(fetchAllGarmentTypes());
        dispatch(fetchAllLabels());
    }, [dispatch]);

    const uploadPdfFile = async (file) => {
        // event.preventDefault()
        if (file.name) {
            // console.log("INSIDE handleTracerCertificateSubmit")
            const formData = new FormData()
            formData.append("upload", file)
            // console.log("formdata", formData)
            try {
                // console.log("INSIDE handleTracerCertificateSubmit TRY")
                const response = await uploadPdf(formData);
                return response.data.filePath;
            }
            catch (err) {
                setIsSubmit(false);
                toast.error('Submission Failed!');
                // console.log("INSIDE handleTracerCertificateSubmit CATCH", err)
                setError(true)
                // return 0;
                // setErrorMessage(err.response.data.msg)
            }
        }
    }

    const handleCreateTagRequestSubmit = async(data) => {
        const tracerCertificateName = await uploadPdfFile(tracerCertificateFile);
        const fptGptReportName = await uploadPdfFile(fptGptreportFile);
        data.tracerCertificateName = tracerCertificateName ? tracerCertificateName : '';
        data.fptGptReportName = fptGptReportName ? fptGptReportName : '';
        // console.log("tracerCertificateName",tracerCertificateName,"fptGptReportName",fptGptReportName);
        // console.log("data isssssss",data,"isSubmit",isSubmit,"error",error)
        // if(tracerCertificateName != 0 && fptGptReportName != 0){
       // TODO: To dispatch createTagRequest only if file upload is successfull.
        dispatch(createTagRequest(data))
        .then((response) => {
            // console.log("RESPONSEE",response);
            if(response.type === 'tag/createTagRequest/fulfilled')
            setSuccess(true);
        })
        // }       
    }

    const handleClick1 = () => {
        if (fileInputRef1.current) {
            fileInputRef1.current.click();
        }
    };

    const handleTracerCertificateFileUpload = (e) => {
        if (e.target.files[0]) {
            setFileUrl(URL.createObjectURL(e.target.files[0]));
            settracerCertificateFile(e.target.files[0])
        }
    };

    const handleClick2 = () => {
        if (fileInputRef2.current) {
            fileInputRef2.current.click();
        }
    };

    const handleFptGptFileUpload = (e) => {
        if (e.target.files[0]) {
            setFileUrl(URL.createObjectURL(e.target.files[0]));
            setFptGptreportFileFile(e.target.files[0])
        }
    };
    

    return(
        <>
             <div>
                    <h1 className="fprimary">Create Request Tag</h1>
            </div>
            <div className="card mt-3 bg-stage">
                <div className="card-body">                  
                        <div className="row">
                            <div className="col-md-4">
                                <div className="d-flex justify-content-between indect">
                                    <div className="left-box w-100 border-end pe-2">
                                        <p className="font-13 mb-0">Purchase Order Number/Style No</p>
                                        <div className="bg-slash font-14">{order?.order?.orderNumber}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-between indect">
                                    <div className="left-box w-100 border-end pe-2">
                                        <p className="font-13 mb-0">Birla Fiber %</p>
                                        <div className="bg-slash font-14">{order?.order?.orderProducts[0]?.blendPercentage} % Blend of Birla Cellulose</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="mt-3">
                                    <h4 className="font-18">Product Description</h4>
                                    <p className="font-13">
                                     {order?.order?.orderDescription}
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                        <Formik
                            initialValues={initialState}
                            enableReinitialize
                            validationSchema={CREATE_TAG_REQUEST_VALIDATION}
                            // added below 2 lines 
                            validateOnBlur={false} // Disable validation on blur
                            validateOnChange={false}
                            onSubmit={(values, { setSubmitting }) => {
                                const formattedValues = {
                                    ...values,
                                    // orderDate: values.orderDate.format('YYYY-MM-DD'),
                                    // orderExpectedDate: values.orderExpectedDate.format('YYYY-MM-DD'),
                                };
                                // console.log("formattedValues",formattedValues);
                                // onSubmit(formattedValues);
                                handleCreateTagRequestSubmit(formattedValues);
                                setSubmitting(false);
                            }}
                        >{({ values, errors, handleChange, handleBlur, handleSubmit, setFieldValue, touched }) => (
                            <form onSubmit={handleSubmit}>
                       <div className="row">
                            
                            <div className="col-md-3 cs-form mb-3">
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    className='md-input'
                                    style={{width:"172%"}}
                                    options={labelOptions}
                                    getOptionLabel={(option) => option.label || ''}
                                    value={labelOptions.find(option => option.value === values.label) || null}
                                    onChange={(event, newValue) => {
                                        handleChange({ target: { name: 'label', value: newValue?.value || '' } });
                                    }}
                                    onBlur={handleBlur}
                                    renderInput={(params) => (
                                        <TextField
                                             {...params}
                                            // label={t('createOrder.supplier')}
                                            label='Brand Label*'
                                            style={{width:"58%"}}
                                             error={touched.label && Boolean(errors.label)}
                                             helperText={touched.label && errors.label}
                                        />
                                    )}
                                />
                            </div>
                            <div className="col-md-3 cs-form mb-3">
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    className='md-input'
                                    options={garmentTypeOptions}
                                    getOptionLabel={(option) => option.label || ''}
                                    value={garmentTypeOptions.find(option => option.value === values.garmentType) || null}
                                    onChange={(event, newValue) => {
                                        handleChange({ target: { name: 'garmentType', value: newValue?.value || '' } });
                                    }}
                                    onBlur={handleBlur}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            // label={t('createOrder.supplier')}
                                            label='Garment Type*'
                                            fullWidth
                                            error={touched.garmentType && Boolean(errors.garmentType)}
                                            helperText={touched.garmentType && errors.garmentType}
                                        />
                                    )}
                                />
                            </div>
                            <div className="col-md-3 cs-form mb-3">
                                    <TextField
                                        //label={t('createOrder.purchaseOrder')}
                                        label='Color*'
                                        className='md-input'
                                        name='color'
                                        value={values.color}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.color}
                                        helperText={errors.color}
                                    />
                            </div>
                            <div className="col-md-3 cs-form mb-3">
                                    <TextField
                                        //label={t('createOrder.purchaseOrder')}
                                        label='Remarks'
                                        className='md-input'
                                        name='remarks'
                                        value={values.remarks}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.remarks}
                                        helperText={errors.remarks}
                                    />
                            </div>
                        </div>
                                          
                        <div className="upload image">
                            <div className="row">
                                <div className="col-md-6">
                                    <div>
                                        <h6>Upload Tracer Test Certificate</h6>
                                    </div>
                                    <div>
                                    <button type="button" className="btn btn-light grey-btn lg-btn" onClick={handleClick1}>
                                        Upload file
                            </button>
                            {/* Hidden file input */}
                            <input
                                type="file"
                                ref={fileInputRef1}
                                style={{ display: "none" }}
                                onChange={handleTracerCertificateFileUpload}
                            />
                            {tracerCertificateFile?.name && <p>Selected file: {tracerCertificateFile.name}</p>}
                                    </div>
                                    <div>
                                        <h6 style={{color:"red", fontSize:"x-small", marginTop:"1%"}}>FileType Allowed : jpg,jpeg,png and pdf & *Max FileSize: 5MB</h6>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div>
                                        <h6>FPT/GPT</h6>
                                    </div>
                                    <div>
                                    <button type="button" className="btn btn-light grey-btn lg-btn" onClick={handleClick2}>
                                    Upload file
                            </button>
                            {/* Hidden file input */}
                            <input
                                type="file"
                                ref={fileInputRef2}
                                style={{ display: "none" }}
                                onChange={handleFptGptFileUpload}
                            />
                            {fptGptreportFile?.name && <p>Selected file: {fptGptreportFile.name}</p>}
                                    </div>
                                    <div>
                                        <h6 style={{color:"red", fontSize:"x-small", marginTop:"1%"}}>FileType Allowed : jpg,jpeg,png and pdf & *Max FileSize: 5MB</h6>
                                    </div>
                                </div>
                            </div>
                           
                        </div>

                        <div className="row">
                            <div className="col-md-4 cs-form mb-3 mt-3">
                                <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='Contact Person Name(Applicant)*'
                                            className='md-input'
                                            name='contactName'
                                            value={values.contactName}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.contactName}
                                            helperText={errors.contactName}
                                />
                            </div>
                            <div className="col-md-4 cs-form mb-3 mt-3">
                                <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='Contact Person Number(Applicant)*'
                                            className='md-input'
                                            name='contactNo'
                                            value={values.contactNo}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.contactNo}
                                            helperText={errors.contactNo}
                                />
                            </div>
                            <div className="col-md-4 cs-form mb-3 mt-3">
                                <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='Delivery Address*'
                                            className='md-input'
                                            name='address'
                                            value={values.address}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.address}
                                            helperText={errors.address}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-4 cs-form mb-3">
                                <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='GST Number*'
                                            className='md-input'
                                            name='gst'
                                            value={values.gst}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.gst}
                                            helperText={errors.gst}
                                />
                            </div>
                            <div className="col-md-4 cs-form mb-3">
                                <TextField
                                            //label={t('createOrder.purchaseOrder')}
                                            label='PIN Code*'
                                            className='md-input'
                                            name='pincode'
                                            value={values.pincode}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.pincode}
                                            helperText={errors.pincode}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 cs-form mb-3">
                                    <TextField
                                                //label={t('createOrder.purchaseOrder')}
                                                label='Email IDs for Notifications(Comma Separated Emails)*'
                                                className='md-input'
                                                name='email'
                                                value={values.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.email}
                                                helperText={errors.email}
                                    />
                                </div>
                        </div>
                       
                        <div className="save buttons">
                            <Button style={{backgroundColor:"green", color:"white", textTransform:"capitalize"}} onClick={()=>navigate(-1)}>Back</Button>
                            <Button style={{backgroundColor:"green", color:"white", marginLeft:"86%", textTransform:"capitalize"}} type='submit' onClick={handleSubmit}>Submit</Button>
                        </div>
                        </form>
            )}
            </Formik >
            {success &&
                    <SuccessModal
                        isOpen={success}
                        msg={`Tag Requested Successfully`}
                        navigatePage={navigatePage}
                    />}
                </div>
            </div>
           
        </>
    )

}
export default CreateTagRequest;